import React from 'react';
import pt from 'prop-types';

import { StorefrontEditorSidebarIcon } from 'components/storefront/editor/icon';

function SectionLabel({ label }) {
  if (!label) {
    return null;
  }

  return (
    <div className="section-overlay--label">
      <StorefrontEditorSidebarIcon type={label} width={12} height={12} />
      {label}
    </div>
  );
}

SectionLabel.propTypes = {
  label: pt.string,
};

export default React.memo(SectionLabel);
